import Http from "@services/http";
import BaseApi from "@api/base.api";

export default class ChatApi extends BaseApi {
    static get entity() {
        return "chats";
    }

    static async getMessages(chatId, params = {}) {
        return await Http.get(`chats/${chatId}/messages`, params);
    }

    static async sendMessage(chatId, data) {
        return await Http.post(`chats/${chatId}/messages`, data);
    }

    static async attachFiles(chatId, data) {
        return await Http.post(`chats/${chatId}/attachments`, data);
    }

    static async updateLikeAction(messageId, action) {
        return await Http.post(`chat-messages/${messageId}/like-action`, { action });
    }

    static async createGeneralChat(action = 'new') {
        return await Http.post('chats/general/create', { action });
    }

    static async checkGeneralChats() {
        return await Http.get('chats/general/check');
    }
}

